import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { SlideBackground } from '@/types/slides'
import GridLines from './GridLines.vue'
import useSlideBackgroundStyle from '@/hooks/useSlideBackgroundStyle'


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewportBackground',
  setup(__props) {

const { gridLineSize } = storeToRefs(useMainStore())
const { currentSlide } = storeToRefs(useSlidesStore())
const background = computed<SlideBackground | undefined>(() => currentSlide.value?.background)

const { backgroundStyle } = useSlideBackgroundStyle(background)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "viewport-background",
    style: _normalizeStyle(_unref(backgroundStyle))
  }, [
    (_unref(gridLineSize))
      ? (_openBlock(), _createBlock(GridLines, { key: 0 }))
      : _createCommentVNode("", true)
  ], 4))
}
}

})